import type { ConfigMap } from './custom-app-config-schema';

export const customConstants: ConfigMap = {
  "wocncb": {
    "tenant": {
      "id": "4c80ce98-ef6c-41c8-ab54-f4db19c75136",
      "name": "WOCNCB"
    },
    "supportEmail": "info@wocncb.org",
    "companyName": "PSI",
    "app": {
      "id": "3dc9d834-de55-4863-b55b-dc155b1772f1",
      "name": "WOCNCB",
      "scheme": "wocncb.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "BC53J54M4K",
          "ascIssuerId": "69f6e117-aacb-485b-ba74-a8f7e2551649",
          "ascKeyId": "W4K53B5C68",
          "ascApiKeyP8": "62f548b6-6866-4cd3-89e1-6123adf48e99",
          "ascAppId": "6751701252"
        },
        "android": {
          "versionCode": 8,
          "package": "com.memorang.psi.wocncb",
          "googleServicesJson": "e00323a3-fa9b-405e-98c2-7beab336d046",
          "serviceAccountJson": "63c77907-0fe6-4fc5-901c-d35ba6c91753"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.wocncb.testprep",
          "buildNumberState": {
            "currentVersion": "1.0.9",
            "buildNumber": 2
          }
        }
      },
      "version": "1.0.18",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "opensans",
      "trademark": "PSI",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "231157f1f863de509dee703a59a7eae2"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/icon_new.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/icon_new.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_logo_stacked_light_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_logo_stacked_dark_new.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_light_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark_new.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/app_default_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.wocncb.org",
        "privacy": "https://app.wocncb.org/legal/privacy",
        "tos": "https://app.wocncb.org/legal/terms",
        "ios": "https://apps.apple.com/tn/app/wocncb-practice-exam-tool/id6751701252",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.wocncb&hl",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.wocncb.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_AjPruGvspvUXzefpAWxOIHvjvPD",
          "android": "goog_HAXzINaGLxSfBduzHQAFiJHysEZ"
        },
        "oneSignalAppId": "92935195-1416-45d0-8318-57659142569b",
        "clerk": {
          "publishableKeyDev": "pk_test_Y29tcGxldGUtbWVlcmthdC02NS5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLndvY25jYi5vcmck"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "WOCNCB AI",
        "alias": "WOCNCB AI",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/icon.png",
        "disclaimer": {
          "enabled": true,
          "title": "Disclaimer",
          "body": "**{{agentName}}** can make mistakes. Use it at your own discretion and verify important information."
        },
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your AI Learning Assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for WOCNCB"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "Authored by the wocncb team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/WOCNCB/icons/landing.webp"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true,
        "crossTagSelection": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:51.310Z",
            "version": "1.0.18"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery",
      "showRedeem": true
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "title": "Your privacy matters",
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "Here's how we protect and use your data"
        },
        "isMobile": true,
        "ctai18n": {
          "en-US": "Continue"
        },
        "data": [
          {
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "icon": "shield-check-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "icon": "lock-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "titlei18n": {
              "en-US": "You control your data"
            },
            "icon": "account-cog-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam",
        "description": "onboarding.steps.chooseContext.description"
      },
      {
        "step": "examDate",
        "enabled": true,
        "title": "Choose your Exam Date",
        "description": "onboarding.steps.testDate.description"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(148, 143, 153)",
          "primary": "rgb(211, 187, 255)",
          "surface": "rgb(29, 27, 30)",
          "backdrop": "rgba(50, 47, 55, 0.4)",
          "tertiary": "rgb(240, 183, 197)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(38, 35, 41)",
            "level2": "rgb(44, 40, 48)",
            "level3": "rgb(49, 45, 55)",
            "level4": "rgb(51, 46, 57)",
            "level5": "rgb(55, 49, 62)"
          },
          "onPrimary": "rgb(59, 29, 112)",
          "onSurface": "rgb(230, 225, 230)",
          "secondary": "rgb(255, 184, 107)",
          "background": "rgb(29, 27, 30)",
          "onTertiary": "rgb(74, 37, 48)",
          "onSecondary": "rgb(73, 41, 0)",
          "onBackground": "rgb(230, 225, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(107, 78, 162)",
          "inverseSurface": "rgb(230, 225, 230)",
          "outlineVariant": "rgb(73, 69, 78)",
          "surfaceVariant": "rgb(73, 69, 78)",
          "surfaceDisabled": "rgba(230, 225, 230, 0.12)",
          "inverseOnSurface": "rgb(50, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(203, 196, 207)",
          "primaryContainer": "rgb(83, 54, 136)",
          "onSurfaceDisabled": "rgba(230, 225, 230, 0.38)",
          "tertiaryContainer": "rgb(100, 59, 70)",
          "onPrimaryContainer": "rgb(235, 221, 255)",
          "secondaryContainer": "rgb(104, 61, 0)",
          "onTertiaryContainer": "rgb(255, 217, 225)",
          "onSecondaryContainer": "rgb(255, 220, 188)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(122, 117, 127)",
          "primary": "rgb(107, 78, 162)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(50, 47, 55, 0.4)",
          "tertiary": "rgb(126, 82, 93)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(248, 242, 250)",
            "level2": "rgb(243, 237, 248)",
            "level3": "rgb(239, 232, 245)",
            "level4": "rgb(237, 230, 244)",
            "level5": "rgb(234, 227, 242)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(29, 27, 30)",
          "secondary": "rgb(137, 81, 0)",
          "background": "rgb(255, 251, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(29, 27, 30)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(211, 187, 255)",
          "inverseSurface": "rgb(50, 48, 51)",
          "outlineVariant": "rgb(203, 196, 207)",
          "surfaceVariant": "rgb(231, 224, 235)",
          "surfaceDisabled": "rgba(29, 27, 30, 0.12)",
          "inverseOnSurface": "rgb(245, 239, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(73, 69, 78)",
          "primaryContainer": "rgb(235, 221, 255)",
          "onSurfaceDisabled": "rgba(29, 27, 30, 0.38)",
          "tertiaryContainer": "rgb(255, 217, 225)",
          "onPrimaryContainer": "rgb(38, 0, 89)",
          "secondaryContainer": "rgb(255, 220, 188)",
          "onTertiaryContainer": "rgb(49, 16, 27)",
          "onSecondaryContainer": "rgb(44, 23, 0)"
        }
      }
    }
  },
  "toefl": {
    "tenant": {
      "id": "5c5a1f03-3dd8-4db4-9a72-77a1686971d9",
      "name": "TOEFL"
    },
    "supportEmail": "TOEFL@ets.org",
    "companyName": "ETS",
    "app": {
      "id": "5ac37912-3205-430a-b88c-0660ddb449c8",
      "name": "TOEFL Practice",
      "scheme": "toefl.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "WGC236CZU9",
          "ascIssuerId": "",
          "ascKeyId": "",
          "ascApiKeyP8": "",
          "ascAppId": "6738998541"
        },
        "android": {
          "versionCode": 56,
          "package": "org.ets.toeflpracticeaicoach",
          "googleServicesJson": "",
          "serviceAccountJson": ""
        },
        "ios": {
          "bundleIdentifier": "org.ets.toeflpracticeaicoach",
          "buildNumberState": {
            "currentVersion": "1.0.17",
            "buildNumber": 2
          }
        }
      },
      "version": "1.0.21",
      "font": "greetstandard",
      "trademark": "TOEFL iBT",
      "showDiagnostic": false,
      "purchase": {
        "baseSku": "com.toefl.app.prep"
      },
      "masteryLevels": [
        {
          "id": "belowBasic",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "session.masteryLevels.belowBasic"
          },
          "level": "low"
        },
        {
          "id": "basic",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 5,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "session.masteryLevels.basic"
          },
          "level": "low"
        },
        {
          "id": "belowLowIntermediate",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 4,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "session.masteryLevels.belowLowIntermediate"
          },
          "level": "low"
        },
        {
          "id": "lowIntermediate",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "session.masteryLevels.lowIntermediate"
          },
          "level": "low"
        },
        {
          "id": "highIntermediate",
          "darkColor": "#77851C",
          "lightColor": "#6A780E",
          "sortOrder": 2,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              60,
              79
            ],
            "points": [
              13,
              16
            ]
          },
          "alias": {
            "title": "session.masteryLevels.highIntermediate"
          },
          "level": "medium"
        },
        {
          "id": "advanced",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "session.masteryLevels.advanced"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            39
          ],
          "range": "0-59",
          "color": "rgba(212, 84, 84, 1)",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            40,
            59
          ],
          "range": "60-79",
          "color": "rgba(181, 77, 33, 1)",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            60,
            100
          ],
          "range": "80-100",
          "color": "rgba(82, 167, 141, 1)",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 17,
        "answer": 15
      },
      "componentOverrides": {
        "button": {
          "labelStyle": {
            "letterSpacing": 2,
            "textTransform": "uppercase"
          }
        }
      },
      "analytics": {
        "mixpanel": {
          "id": "f2b45ce0886396e02b9daa8aee85b803"
        }
      },
      "logo": {
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_dark.png?t=2024-12-09T05%3A34%3A02.187Z"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/stacked_dark.png?t=2024-12-09T05%3A34%3A02.187Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.toefl.com",
        "privacy": "https://www.ets.org/legal/privacy.html",
        "tos": "https://www.ets.org/legal/terms.html",
        "ios": "https://apps.apple.com/us/app/official-toefl-practice/id6738998541",
        "android": "https://play.google.com/store/apps/details?id=org.ets.toeflpracticeaicoach",
        "redeemSupportUrl": "https://www.ets.org/legal/terms.html",
        "companyUrl": "https://ets.org"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_hycCrAhlgNukJDRuKuLsljTgeiY",
          "android": "goog_ZcyeWszvzTgMceoTRNwASRlBkfh"
        },
        "oneSignalAppId": "76841974-61ff-4d8c-a190-b95ce7789e0b",
        "clerk": {
          "publishableKeyDev": "pk_test_Zmlyc3QtY29sdC0zNy5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnRvZWZsLmNvbSQ"
        }
      },
      "tagType": {
        "en-US": "skill",
        "ja-JP": "スキル",
        "zh-CN": "技能"
      },
      "aiAssistant": {
        "title": "AI Learning Agent",
        "alias": "TOEFL AI",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/toefl/icons/aila.png",
        "showOriginalQuestion": false,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for TOEFL practice"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official TOEFL team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/toefl-items//login-graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "filters": [
          {
            "label": {
              "en-US": "Not answered",
              "ja-JP": "未回答",
              "zh-CN": "未回答"
            },
            "distKey": "none"
          },
          {
            "label": {
              "en-US": "Basic",
              "ja-JP": "基礎",
              "zh-CN": "基础"
            },
            "distKey": "basic",
            "color": "rgba(191, 0, 0, 1)"
          },
          {
            "label": {
              "en-US": "Intermediate",
              "ja-JP": "中級",
              "zh-CN": "中级"
            },
            "distKey": "intermediate",
            "color": "#6A780E"
          },
          {
            "label": {
              "en-US": "Advanced",
              "ja-JP": "上級",
              "zh-CN": "高级"
            },
            "distKey": "advanced",
            "color": "rgba(0, 129, 89, 1)"
          }
        ]
      },
      "accountSettings": {
        "showFaqs": true,
        "showPurchasedProducts": true,
        "faqs": [
          {
            "question": "What is the TOEFL test?",
            "answer": "The TOEFL (Test of English as a Foreign Language) measures your ability to use and understand English at the university level. It tests your reading, listening, speaking, and writing skills.",
            "locale": "en-US",
            "order": 1
          },
          {
            "question": "什么是托福考试？",
            "answer": "托福（Test of English as a Foreign Language）考试评估你在大学水平上使用和理解英语的能力。它测试你的阅读、听力、口语和写作技能。",
            "locale": "zh-CN",
            "order": 1
          },
          {
            "question": "TOEFLテストとは何ですか？",
            "answer": "TOEFL（Test of English as a Foreign Language）は、大学レベルで英語を使用・理解する能力を測定するテストです。リーディング、リスニング、スピーキング、ライティングの各スキルが評価されます。",
            "locale": "ja-JP",
            "order": 1
          },
          {
            "question": "Who can use this app?",
            "answer": "This app is designed for anyone preparing for the TOEFL, whether you are a student, working professional, or just looking to improve your English skills.",
            "locale": "en-US",
            "order": 2
          },
          {
            "question": "谁可以使用这个应用程序？",
            "answer": "这个应用程序适用于任何准备托福考试的人，无论你是学生、在职专业人士，还是只是想提高英语技能的人。",
            "locale": "zh-CN",
            "order": 2
          },
          {
            "question": "このアプリは誰が利用できますか？",
            "answer": "このアプリはTOEFLの準備をしている学生、社会人、または英語力向上を目指すすべての方を対象としています。",
            "locale": "ja-JP",
            "order": 2
          },
          {
            "question": "Do I need prior knowledge of TOEFL to use the app?",
            "answer": "No, this app is beginner-friendly and provides diagnostic tests to help you understand your current level.",
            "locale": "en-US",
            "order": 3
          },
          {
            "question": "使用这个应用程序需要托福的先前知识吗？",
            "answer": "不需要，这个应用程序对初学者友好，并提供诊断测试以帮助你了解当前的水平。",
            "locale": "zh-CN",
            "order": 3
          },
          {
            "question": "このアプリを使用するためにTOEFLの事前知識は必要ですか？",
            "answer": "いいえ。このアプリは初心者向けに設計されており、現在のレベルを把握するための診断テストを提供しています。",
            "locale": "ja-JP",
            "order": 3
          },
          {
            "question": "Is this app free?",
            "answer": "The app has free features, but premium features, like detailed progress tracking and custom study sessions, are available with a subscription.",
            "locale": "en-US",
            "order": 34
          },
          {
            "question": "这个应用程序是免费的吗？",
            "answer": "应用程序有免费功能，但高级功能，如详细的进度跟踪和定制学习课程，需要订阅才能使用。",
            "locale": "zh-CN",
            "order": 34
          },
          {
            "question": "このアプリは無料ですか？",
            "answer": "アプリには無料機能が含まれていますが、詳細な進捗追跡やカスタム学習セッションなどのプレミアム機能はサブスクリプションでご利用いただけます。",
            "locale": "ja-JP",
            "order": 34
          },
          {
            "question": "How do I create an account?",
            "answer": "Tap on \"Continue with Email,\" enter your email address, and follow the verification link sent to your email.",
            "locale": "en-US",
            "order": 35
          },
          {
            "question": "如何创建账户？",
            "answer": "点击“通过电子邮件继续”，输入你的电子邮件地址，并按照发送到你邮箱的验证链接进行操作。",
            "locale": "zh-CN",
            "order": 35
          },
          {
            "question": "アカウントを作成するにはどうすればいいですか？",
            "answer": "「メールで続ける」をタップし、メールアドレスを入力後、送信された確認リンクに従ってください。",
            "locale": "ja-JP",
            "order": 35
          },
          {
            "question": "What should I do if I don’t receive the verification email?",
            "answer": "Check your spam or junk folder. If it’s not there, tap “Resend magic link” on the app.",
            "locale": "en-US",
            "order": 36
          },
          {
            "question": "如果我没有收到验证邮件该怎么办？",
            "answer": "检查你的垃圾邮件或垃圾箱。如果没有找到，请在应用程序中点击“重新发送魔法链接”。",
            "locale": "zh-CN",
            "order": 36
          },
          {
            "question": "確認メールが届かない場合はどうすればいいですか？",
            "answer": "迷惑メールフォルダーを確認してください。見つからない場合は、アプリ内の「マジックリンクを再送信」をタップしてください。",
            "locale": "ja-JP",
            "order": 36
          },
          {
            "question": "Can I change my exam date later?",
            "answer": "Yes, you can update your exam date in the \"Account Settings\" section.",
            "locale": "en-US",
            "order": 37
          },
          {
            "question": "我可以后来更改考试日期吗？",
            "answer": "可以，你可以在“账户设置”部分更新你的考试日期。",
            "locale": "zh-CN",
            "order": 37
          },
          {
            "question": "後で試験日を変更できますか？",
            "answer": "はい、アカウント設定セクションから試験日を更新できます。",
            "locale": "ja-JP",
            "order": 37
          },
          {
            "question": "How do I delete my account?",
            "answer": "Go to \"Account Settings\" and select \"Delete Account.\" Be aware that this action is permanent.",
            "locale": "en-US",
            "order": 38
          },
          {
            "question": "如何删除我的账户？",
            "answer": "前往“账户设置”并选择“删除账户”。请注意，此操作是永久性的。",
            "locale": "zh-CN",
            "order": 38
          },
          {
            "question": "アカウントを削除するにはどうすればいいですか？",
            "answer": "アカウント設定に移動し、「アカウント削除」を選択してください。この操作は取り消しできないためご注意ください。",
            "locale": "ja-JP",
            "order": 38
          },
          {
            "question": "What is the \"Quick Study\" option?",
            "answer": "\"Quick Study\" allows you to practice random questions quickly based on your selected skills or diagnostic results.",
            "locale": "en-US",
            "order": 39
          },
          {
            "question": "“快速学习”选项是什么？",
            "answer": "“快速学习”允许你根据选择的技能或诊断结果快速练习随机问题。",
            "locale": "zh-CN",
            "order": 39
          },
          {
            "question": "『クイックスタディ』オプションとは何ですか？",
            "answer": "『クイックスタディ』では、選択したスキルまたは診断結果に基づいてランダムな問題を素早く練習できます。",
            "locale": "ja-JP",
            "order": 39
          },
          {
            "question": "How do I set a custom study session?",
            "answer": "Navigate to the \"Home\" screen, and choose the skills or sections you want to focus on.",
            "locale": "en-US",
            "order": 40
          },
          {
            "question": "如何设置自定义学习课程？",
            "answer": "导航到“主页”屏幕，选择你想要专注的技能或部分。",
            "locale": "zh-CN",
            "order": 40
          },
          {
            "question": "カスタム学習セッションの設定方法は？",
            "answer": "ホーム画面に移動し、集中したいスキルやセクションを選択してください。",
            "locale": "ja-JP",
            "order": 40
          },
          {
            "question": "Can I track my progress?",
            "answer": "Yes, the \"Progress\" section shows your mastery, completed items, and areas that need improvement.",
            "locale": "en-US",
            "order": 41
          },
          {
            "question": "我可以跟踪我的进度吗？",
            "answer": "可以，“进度”部分显示你的掌握情况、完成的项目以及需要改进的领域。",
            "locale": "zh-CN",
            "order": 41
          },
          {
            "question": "進捗を追跡できますか？",
            "answer": "はい、「進捗」セクションで習熟度、完了した項目、改善が必要な分野を確認できます。",
            "locale": "ja-JP",
            "order": 41
          },
          {
            "question": "What is the \"Leaderboard\"?",
            "answer": "The \"Leaderboard\" lets you compare your progress with other users. You earn XP points by completing activities.",
            "locale": "en-US",
            "order": 42
          },
          {
            "question": "“排行榜”是什么？",
            "answer": "“排行榜”让你可以与其他用户比较进度。通过完成活动，你可以获得XP积分。",
            "locale": "zh-CN",
            "order": 42
          },
          {
            "question": "『リーダーボード』とは何ですか？",
            "answer": "『リーダーボード』では、他のユーザーと進捗を比較できます。アクティビティを完了するとXPポイントが獲得されます。",
            "locale": "ja-JP",
            "order": 42
          },
          {
            "question": "What are the four skills tested in the TOEFL?",
            "answer": "Reading, Listening, Speaking, and Writing.",
            "locale": "en-US",
            "order": 43
          },
          {
            "question": "托福考试测试哪些四项技能？",
            "answer": "阅读、听力、口语和写作。",
            "locale": "zh-CN",
            "order": 43
          },
          {
            "question": "TOEFLでテストされる4つのスキルは何ですか？",
            "answer": "リーディング、リスニング、スピーキング、ライティングです。",
            "locale": "ja-JP",
            "order": 43
          },
          {
            "question": "How does the app help me improve my speaking skills?",
            "answer": "The app provides speaking prompts, voice recording options, and evaluations to help you practice.",
            "locale": "en-US",
            "order": 44
          },
          {
            "question": "这个应用程序如何帮助我提高口语技能？",
            "answer": "应用程序提供口语提示、语音录制选项和评估，帮助你练习。",
            "locale": "zh-CN",
            "order": 44
          },
          {
            "question": "アプリはどのようにスピーキングスキルの向上をサポートしますか？",
            "answer": "スピーキングのプロンプト、音声録音機能、および評価を通じて練習を支援します。",
            "locale": "ja-JP",
            "order": 44
          },
          {
            "question": "Can I get feedback on my answers?",
            "answer": "Premium users can receive detailed feedback for speaking and writing tasks.",
            "locale": "en-US",
            "order": 46
          },
          {
            "question": "我可以获得答案的反馈吗？",
            "answer": "高级用户可以获得口语和写作任务的详细反馈。",
            "locale": "zh-CN",
            "order": 46
          },
          {
            "question": "自分の回答に対してフィードバックはもらえますか？",
            "answer": "プレミアムユーザーは、スピーキングおよびライティングタスクに対して詳細なフィードバックを受けることができます。",
            "locale": "ja-JP",
            "order": 46
          },
          {
            "question": "The app isn’t loading. What should I do?",
            "answer": "Ensure your internet connection is stable. Try restarting the app or updating it to the latest version.",
            "locale": "en-US",
            "order": 47
          },
          {
            "question": "应用程序无法加载。我该怎么办？",
            "answer": "确保你的互联网连接稳定。尝试重新启动应用程序或更新到最新版本。",
            "locale": "zh-CN",
            "order": 47
          },
          {
            "question": "アプリが読み込まれません。どうすればよいですか？",
            "answer": "インターネット接続が安定しているか確認し、アプリを再起動するか、最新バージョンに更新してください。",
            "locale": "ja-JP",
            "order": 47
          },
          {
            "question": "What should I do if my progress isn’t syncing?",
            "answer": "Check your internet connection and make sure you’re logged into the app. If the issue persists, contact support.",
            "locale": "en-US",
            "order": 48
          },
          {
            "question": "如果我的进度不同步，我该怎么办？",
            "answer": "检查你的互联网连接，并确保你已登录应用程序。如果问题仍然存在，请联系支持团队。",
            "locale": "zh-CN",
            "order": 48
          },
          {
            "question": "進捗が同期されない場合はどうすればいいですか？",
            "answer": "インターネット接続を確認し、同じアカウントでログインしていることを確認してください。問題が解決しない場合はサポートにお問い合わせください。",
            "locale": "ja-JP",
            "order": 48
          },
          {
            "question": "How do I enable dark mode?",
            "answer": "Go to \"Account Settings\" and toggle the \"Dark Mode\" option.",
            "locale": "en-US",
            "order": 49
          },
          {
            "question": "如何启用深色模式？",
            "answer": "前往“账户设置”并切换“深色模式”选项。",
            "locale": "zh-CN",
            "order": 49
          },
          {
            "question": "ダークモードを有効にするにはどうすればいいですか？",
            "answer": "アカウント設定に移動し、「ダークモード」オプションを切り替えてください。",
            "locale": "ja-JP",
            "order": 49
          },
          {
            "question": "Can I use the app on multiple devices?",
            "answer": "Yes, your progress is synced across devices as long as you log in with the same account.",
            "locale": "en-US",
            "order": 50
          },
          {
            "question": "我可以在多个设备上使用这个应用程序吗？",
            "answer": "可以，只要你使用同一个账户登录，你的进度将在多个设备间同步。",
            "locale": "zh-CN",
            "order": 50
          },
          {
            "question": "複数のデバイスでアプリを利用できますか？",
            "answer": "はい、同じアカウントでログインしている限り、進捗は複数のデバイスで同期されます。",
            "locale": "ja-JP",
            "order": 50
          },
          {
            "question": "What if I don’t understand a question?",
            "answer": "Use the \"Show Hint\" button for additional guidance. You can also review explanations after answering.",
            "locale": "en-US",
            "order": 51
          },
          {
            "question": "如果我不理解一个问题怎么办？",
            "answer": "使用“显示提示”按钮获取额外的指导。你也可以在回答后查看解释。",
            "locale": "zh-CN",
            "order": 51
          },
          {
            "question": "質問が理解できない場合はどうすればいいですか？",
            "answer": "「ヒントを表示」ボタンを使用して追加のガイダンスを得るか、回答後に解説を確認してください。",
            "locale": "ja-JP",
            "order": 51
          },
          {
            "question": "Does the app support other languages?",
            "answer": "The app interface is in English, but you can enable translated instructions in your native language from \"Settings.\"",
            "locale": "en-US",
            "order": 52
          },
          {
            "question": "这个应用程序支持其他语言吗？",
            "answer": "应用程序界面为英文，但你可以在“设置”中启用母语的翻译说明。",
            "locale": "zh-CN",
            "order": 52
          },
          {
            "question": "アプリは他の言語をサポートしていますか？",
            "answer": "アプリのインターフェースは英語ですが、「設定」から母国語への翻訳指示を有効にできます。",
            "locale": "ja-JP",
            "order": 52
          },
          {
            "question": "What should I focus on if my test date is close?",
            "answer": "Prioritize your weakest skills and complete the diagnostic tests for targeted practice.",
            "locale": "en-US",
            "order": 53
          },
          {
            "question": "如果我的考试日期临近，我应该专注于什么？",
            "answer": "优先练习你最薄弱的技能，并完成诊断测试以进行有针对性的练习。",
            "locale": "zh-CN",
            "order": 53
          },
          {
            "question": "試験日が近い場合、何に重点を置くべきですか？",
            "answer": "弱点となるスキルに重点を置き、診断テストを実施してターゲットを絞った練習を行ってください。",
            "locale": "ja-JP",
            "order": 53
          },
          {
            "question": "Can I practice listening and speaking simultaneously?",
            "answer": "Yes, integrated exercises allow you to listen to audio and respond to related questions.",
            "locale": "en-US",
            "order": 54
          },
          {
            "question": "我可以同时练习听力和口语吗？",
            "answer": "可以，集成的练习允许你听音频并回答相关问题。",
            "locale": "zh-CN",
            "order": 54
          },
          {
            "question": "リスニングとスピーキングを同時に練習できますか？",
            "answer": "はい、統合された演習により、オーディオを聴きながら関連する質問に回答することができます。",
            "locale": "ja-JP",
            "order": 54
          },
          {
            "question": "I am new to TOEFL. Where should I start?",
            "answer": "Begin with the diagnostic test to identify your strengths and weaknesses. Follow the suggested study plan based on your results.",
            "locale": "en-US",
            "order": 55
          },
          {
            "question": "我是托福新手。我应该从哪里开始？",
            "answer": "从诊断测试开始，识别你的优势和弱点。根据结果遵循建议的学习计划。",
            "locale": "zh-CN",
            "order": 55
          },
          {
            "question": "TOEFL初心者ですが、どこから始めればいいですか？",
            "answer": "診断テストから始めて、自分の強みと弱みを把握し、結果に基づいた推奨学習計画に従ってください。",
            "locale": "ja-JP",
            "order": 55
          },
          {
            "question": "How do I set my test date?",
            "answer": "Go to \"Home,\" tap \"Set Date,\" and input your TOEFL test date to create a study plan.",
            "locale": "en-US",
            "order": 56
          },
          {
            "question": "如何设置我的考试日期？",
            "answer": "前往“主页”，点击“设置日期”，输入你的托福考试日期以创建学习计划。",
            "locale": "zh-CN",
            "order": 56
          },
          {
            "question": "試験日を設定するにはどうすればいいですか？",
            "answer": "ホーム画面に移動し、「日付を設定」をタップしてTOEFL試験日を入力し、学習計画を作成してください。",
            "locale": "ja-JP",
            "order": 56
          },
          {
            "question": "How can I provide feedback about the app?",
            "answer": "Navigate to \"Contact Support\" in \"Account Settings\" to share your suggestions or issues.",
            "locale": "en-US",
            "order": 57
          },
          {
            "question": "我如何提供关于应用程序的反馈？",
            "answer": "前往“账户设置”中的“联系支持”分享你的建议或问题。",
            "locale": "zh-CN",
            "order": 57
          },
          {
            "question": "アプリに関するフィードバックはどのように提供できますか？",
            "answer": "アカウント設定内の「サポートに連絡」からご意見や問題点をお知らせください。",
            "locale": "ja-JP",
            "order": 57
          },
          {
            "question": "What should I do if I find a bug?",
            "answer": "Report it through the \"Contact Support\" option. Provide as many details as possible.",
            "locale": "en-US",
            "order": 58
          },
          {
            "question": "如果我发现一个漏洞，我该怎么办？",
            "answer": "通过“联系支持”选项报告。提供尽可能多的细节。",
            "locale": "zh-CN",
            "order": 58
          },
          {
            "question": "バグを発見した場合はどうすればいいですか？",
            "answer": "「サポートに連絡」オプションから報告し、できるだけ詳細な情報を提供してください。",
            "locale": "ja-JP",
            "order": 58
          },
          {
            "question": "Is customer support available in my time zone?",
            "answer": "Yes, support is available 24/7 to assist users globally.",
            "locale": "en-US",
            "order": 59
          },
          {
            "question": "客户支持在我的时区有服务吗？",
            "answer": "是的，支持团队全天候（24/7）为全球用户提供帮助。",
            "locale": "zh-CN",
            "order": 59
          },
          {
            "question": "カスタマーサポートは私のタイムゾーンでも利用可能ですか？",
            "answer": "はい、サポートは24時間365日、世界中のユーザーをサポートしています。",
            "locale": "ja-JP",
            "order": 59
          }
        ],
        "showLanguageSettings": true,
        "showAudioTestDialog": true
      },
      "appAvailabilityRegions": [
        "MX",
        "FR",
        "DE",
        "JP",
        "US"
      ],
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:51.322Z",
            "version": "1.0.21"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "",
      "showRedeem": true
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": false
      },
      "stats": [
        {
          "type": "answered",
          "title": "Answered",
          "icon": "check-all",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "timeElapsed",
          "title": "Time Elapsed",
          "icon": "timer-sand",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Estimated proficiency",
            "ja-JP": "推定習熟度",
            "zh-CN": "估计掌握度"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Performance",
            "ja-JP": "パフォーマンス",
            "zh-CN": "表现"
          }
        }
      ],
      "formative": {
        "showPointsBasedScore": true,
        "maxScore": 30
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Study-Pack",
            "name": "study-pack",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "podcasts",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": false
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Profile",
            "name": "profile",
            "icon": {
              "default": "account-outline",
              "selected": "account"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Library",
            "name": "articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Library",
            "name": "(articles)/articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": null,
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "progress": {
            "low": "rgba(212, 84, 84, 1)",
            "high": "rgba(82, 167, 141, 1)",
            "medium": "rgba(181, 77, 33, 1)"
          },
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "confidence": {
            "low": "rgba(212, 84, 84, 1)",
            "high": "rgba(82, 167, 141, 1)",
            "medium": "rgba(181, 77, 33, 1)"
          },
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(119, 118, 128)",
          "primary": "rgb(78, 83, 183)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(48, 48, 56, 0.4)",
          "progress": {
            "low": "rgba(191, 0, 0, 1)",
            "high": "rgba(0, 129, 89, 1)",
            "medium": "rgba(255, 143, 96, 1)"
          },
          "tertiary": "rgb(121, 83, 106)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(246, 243, 251)",
            "level2": "rgb(241, 238, 249)",
            "level3": "rgb(236, 233, 247)",
            "level4": "rgb(234, 231, 246)",
            "level5": "rgb(230, 228, 245)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(28, 27, 31)",
          "secondary": "rgb(84, 85, 169)",
          "background": "rgb(255, 251, 255)",
          "confidence": {
            "low": "rgba(191, 0, 0, 1)",
            "high": "rgba(0, 129, 89, 1)",
            "medium": "rgba(255, 143, 96, 1)"
          },
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(28, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(143, 148, 255)",
          "inverseSurface": "rgb(49, 48, 52)",
          "outlineVariant": "rgb(199, 197, 208)",
          "surfaceVariant": "rgb(228, 225, 236)",
          "surfaceDisabled": "rgba(28, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(243, 239, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(70, 70, 79)",
          "primaryContainer": "rgb(225, 224, 255)",
          "onSurfaceDisabled": "rgba(28, 27, 31, 0.38)",
          "tertiaryContainer": "rgb(255, 216, 237)",
          "onPrimaryContainer": "rgb(4, 0, 109)",
          "secondaryContainer": "rgb(225, 223, 255)",
          "onTertiaryContainer": "rgb(46, 17, 37)",
          "onSecondaryContainer": "rgb(12, 6, 100)"
        }
      },
      "roundness": 0
    }
  },
  "therapyed": {
    "tenant": {
      "id": "53d94851-4af6-4dfc-943d-92929b3e9dcc",
      "name": "TherapyEd"
    },
    "supportEmail": "info@therapyed.com",
    "companyName": "TherapyEd",
    "app": {
      "id": "db878dfd-9617-456b-b458-14902e06462f",
      "name": "TherapyEd",
      "scheme": "therapyed.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1590041414"
        },
        "android": {
          "versionCode": 104,
          "package": "com.memorang.therapyed",
          "googleServicesJson": "73a57898-161a-4aa1-837f-e0ba27222a26",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.therapyed",
          "buildNumberState": {
            "currentVersion": "2.1.24",
            "buildNumber": 9
          }
        }
      },
      "version": "2.1.39",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "https://apps.apple.com/us/app/therapyed/id1590041414",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.therapyed"
        },
        "subtitle": "We are currently making improvements to enhance your experience. TherapyEd app will be down for maintenance from 12:30AM-6:30AM PT / 3:30AM-9:30AM ET. We apologize for any inconvenience and appreciate your patience. After the maintenance, the current version of the app will be deprecated. Please update the app from the App Store or Play Store to continue using it."
      },
      "font": "opensans",
      "trademark": "TherapyEd",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "5b3fe7e0378f1a1bd87bc085ddc9b66e"
        }
      },
      "logo": {
        "icon": "https://icon.memorang.com/app-resources/therapyed/ios/icon.png",
        "adaptiveIcon": "https://icon.memorang.com/app-resources/therapyed/android/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_light.png"
          },
          "dark": {
            "uri": "https://memorang-prod-media.s3.amazonaws.com/app-logos/therapyed/company_logo_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.therapyed.com",
        "privacy": "https://app.therapyed.com/legal/privacy",
        "tos": "https://app.therapyed.com/legal/terms",
        "redeemSupportUrl": "https://therapyed.zendesk.com/hc/en-us/articles/6864418376468-How-can-I-redeem-access-to-my-purchased-content-",
        "companyUrl": "https://www.therapyed.com/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_LCnNlSXwMCLCGLQsftcakAoejTs",
          "android": "goog_cFBRaPbCakxtxjBbmsUDprlTzfN"
        },
        "oneSignalAppId": "ac799c9b-47da-4692-b722-ce25feffc4ca",
        "clerk": {
          "publishableKeyDev": "pk_test_ZnJlZS1sZW9wYXJkLTExLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnRoZXJhcHllZC5jb20k"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-therapyed-shared"
        }
      },
      "supportUrl": "https://therapyed.zendesk.com/hc/en-us",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "TherapyEd AI",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/icons/therapyed/icon.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning agent, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for TherapyEd Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official TherapyEd team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/therapyed/therapyed/aibl/landing_graphic.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true,
        "crossTagSelection": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:51.292Z",
            "version": "2.1.39"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domains",
      "showRedeem": false
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "title": "Your privacy matters",
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "Here's how we protect and use your data"
        },
        "isMobile": true,
        "ctai18n": {
          "en-US": "Continue"
        },
        "data": [
          {
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "icon": "shield-check-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "icon": "lock-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "titlei18n": {
              "en-US": "You control your data"
            },
            "icon": "account-cog-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam",
        "description": "onboarding.steps.chooseContext.description"
      },
      {
        "step": "examDate",
        "enabled": true,
        "title": "Choose your Exam Date",
        "description": "onboarding.steps.testDate.description"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "enableSessionReplay": false,
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(140, 145, 153)",
          "primary": "#F78F1E",
          "surface": "rgb(26, 28, 30)",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(196, 203, 151)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(33, 37, 41)",
            "level2": "rgb(37, 42, 48)",
            "level3": "rgb(40, 47, 55)",
            "level4": "rgb(42, 49, 57)",
            "level5": "rgb(44, 52, 62)"
          },
          "onPrimary": "rgb(76, 39, 0)",
          "onSurface": "rgb(226, 226, 230)",
          "secondary": "rgb(157, 202, 255)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(45, 51, 13)",
          "onSecondary": "rgb(0, 50, 87)",
          "onBackground": "rgb(226, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(0, 98, 161)",
          "inverseSurface": "rgb(226, 226, 230)",
          "outlineVariant": "rgb(66, 71, 78)",
          "surfaceVariant": "rgb(66, 71, 78)",
          "surfaceDisabled": "rgba(226, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(194, 199, 207)",
          "primaryContainer": "rgb(109, 58, 0)",
          "onSurfaceDisabled": "rgba(226, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(68, 74, 34)",
          "onPrimaryContainer": "rgb(255, 220, 194)",
          "secondaryContainer": "rgb(0, 73, 123)",
          "onTertiaryContainer": "rgb(224, 231, 177)",
          "onSecondaryContainer": "rgb(208, 228, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(133, 115, 111)",
          "primary": "#ab351a",
          "surface": "rgb(255, 255, 255)",
          "backdrop": "rgba(59, 45, 42, 0.4)",
          "tertiary": "rgb(106, 87, 120)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(255, 255, 255)",
            "level2": "rgb(255, 255, 255)",
            "level3": "rgb(255, 255, 255)",
            "level4": "rgb(255, 255, 255)",
            "level5": "rgb(255, 255, 255)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(32, 26, 25)",
          "secondary": "rgb(0, 98, 162)",
          "background": "#f2f2f2",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(32, 26, 25)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(255, 180, 163)",
          "inverseSurface": "rgb(54, 47, 45)",
          "outlineVariant": "rgb(216, 194, 189)",
          "surfaceVariant": "rgb(245, 221, 216)",
          "surfaceDisabled": "rgba(32, 26, 25, 0.12)",
          "inverseOnSurface": "rgb(251, 238, 235)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(83, 67, 64)",
          "primaryContainer": "rgb(255, 218, 210)",
          "onSurfaceDisabled": "rgba(32, 26, 25, 0.38)",
          "tertiaryContainer": "rgb(242, 218, 255)",
          "onPrimaryContainer": "rgb(61, 6, 0)",
          "secondaryContainer": "rgb(209, 228, 255)",
          "onTertiaryContainer": "rgb(37, 20, 50)",
          "onSecondaryContainer": "rgb(0, 29, 53)"
        }
      }
    }
  },
  "aavsb": {
    "tenant": {
      "id": "36b05d62-872c-404b-9c62-c42a9c5434b8",
      "name": "AAVSB"
    },
    "supportEmail": "info@aavsb.com",
    "companyName": "PSI",
    "app": {
      "id": "86cc8809-4824-4c22-a0f7-88246b597afb",
      "name": "AAVSB",
      "scheme": "aavsb.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6749604020"
        },
        "android": {
          "versionCode": 10,
          "package": "com.memorang.aavsb",
          "googleServicesJson": "b73becbb-6271-4a11-a3e8-2016a479b84a",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.aavsb",
          "buildNumberState": {
            "currentVersion": "1.0.9",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.21",
      "font": "sourcesanspro",
      "trademark": "AAVSB",
      "showDiagnostic": false,
      "showPracticeTests": false,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "c8f990c7eda09ea22a741fd54ff3fde8"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/app_logo_light.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.aavsb.org",
        "privacy": "https://app.aavsb.org/legal/privacy",
        "tos": "https://app.aavsb.org/legal/terms",
        "redeemSupportUrl": "",
        "companyUrl": "https://www.aavsb.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_RiYIviJZZyKVQNLjkzWJQpitxYU",
          "android": "goog_ukzQuWRLGPOokJXXVWhTwETvDRz"
        },
        "oneSignalAppId": "236a14f3-9b96-4664-957c-a44b24fcd7f0",
        "clerk": {
          "publishableKeyDev": "pk_test_c2luY2VyZS1maWxseS0yMy5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmFhdnNiLm9yZyQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AI Study Pawtner",
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/assistant_icon_light.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for AAVSB Test Prep"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official AAVSB team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/AASVB/apps/landing_graphic.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:51.204Z",
            "version": "1.0.21"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Assessments",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": false
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration. Looking to schedule/reschedule your official exam? [**Click here**](https://www.aavsb.org/students-exams/veterinary-technician-national-exam/applying-to-take-the-vtne/)"
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery",
      "showRedeem": false
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Home",
            "name": "study-pack",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(142, 144, 153)",
          "primary": "rgb(172, 199, 255)",
          "surface": "rgb(27, 27, 31)",
          "backdrop": "rgba(45, 48, 56, 0.4)",
          "tertiary": "rgb(221, 188, 223)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(34, 36, 42)",
            "level2": "rgb(39, 41, 49)",
            "level3": "rgb(43, 46, 56)",
            "level4": "rgb(44, 48, 58)",
            "level5": "rgb(47, 51, 62)"
          },
          "onPrimary": "rgb(0, 47, 103)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(255, 176, 206)",
          "background": "rgb(27, 27, 31)",
          "onTertiary": "rgb(63, 40, 68)",
          "onSecondary": "rgb(100, 0, 58)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(46, 93, 168)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(68, 71, 78)",
          "surfaceVariant": "rgb(68, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(196, 198, 208)",
          "primaryContainer": "rgb(9, 69, 142)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(87, 62, 91)",
          "onPrimaryContainer": "rgb(215, 226, 255)",
          "secondaryContainer": "rgb(140, 0, 84)",
          "onTertiaryContainer": "rgb(251, 215, 252)",
          "onSecondaryContainer": "rgb(255, 217, 229)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(116, 119, 127)",
          "primary": "rgb(46, 93, 168)",
          "surface": "rgb(254, 251, 255)",
          "backdrop": "rgba(45, 48, 56, 0.4)",
          "tertiary": "rgb(112, 85, 116)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(244, 243, 251)",
            "level2": "rgb(237, 238, 248)",
            "level3": "rgb(231, 234, 245)",
            "level4": "rgb(229, 232, 245)",
            "level5": "rgb(225, 229, 243)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(27, 27, 31)",
          "secondary": "rgb(173, 35, 109)",
          "background": "rgb(254, 251, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(27, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(172, 199, 255)",
          "inverseSurface": "rgb(47, 48, 51)",
          "outlineVariant": "rgb(196, 198, 208)",
          "surfaceVariant": "rgb(224, 226, 236)",
          "surfaceDisabled": "rgba(27, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(242, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(68, 71, 78)",
          "primaryContainer": "rgb(215, 226, 255)",
          "onSurfaceDisabled": "rgba(27, 27, 31, 0.38)",
          "tertiaryContainer": "rgb(251, 215, 252)",
          "onPrimaryContainer": "rgb(0, 26, 64)",
          "secondaryContainer": "rgb(255, 217, 229)",
          "onTertiaryContainer": "rgb(41, 19, 46)",
          "onSecondaryContainer": "rgb(62, 0, 34)"
        }
      }
    }
  },
  "wpi": {
    "tenant": {
      "id": "1977bda2-690e-434a-a046-bd0e06b55aa7",
      "name": "WPI"
    },
    "supportEmail": "support@app.gowpi.org",
    "companyName": "WPI",
    "app": {
      "id": "5789d9fc-0af8-4061-a5d5-7ae256a6be8c",
      "name": "WPI Exam Prep",
      "scheme": "wpi.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6754835308"
        },
        "android": {
          "versionCode": 4,
          "package": "com.memorang.psi.wpi",
          "googleServicesJson": "292d2e6d-f01c-4408-aef2-2cc674184d08",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.wpi",
          "buildNumberState": {
            "currentVersion": "1.0.18",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.19",
      "maintenance": {
        "enabled": false,
        "title": "Please update your app",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "notoserif",
      "trademark": "PSI",
      "showDiagnostic": false,
      "showPracticeTests": true,
      "purchase": {},
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            55
          ],
          "range": "0-55",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            56,
            69
          ],
          "range": "56-69",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            70,
            100
          ],
          "range": "70-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 18,
        "answer": 18
      },
      "analytics": {
        "mixpanel": {
          "id": "0451a8941c04c763a14b8503d35b062c"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/icon_new.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/icon_new.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/app_logo_default.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/app_logo_default_dark.png"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.gowpi.org",
        "privacy": "https://app.gowpi.org/legal/privacy",
        "tos": "https://app.gowpi.org/legal/terms",
        "ios": "https://apps.apple.com/az/app/wpi-exam-prep/id6754835308",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.wpi&hl=en_IN",
        "companyUrl": "https://www.gowpi.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_xpDPjERhWxDwqMJlfzqvuclSDqs",
          "android": "goog_SJlKLukyjmahxmJtUdUAaCsPsZr"
        },
        "oneSignalAppId": "8145f29b-0446-4778-9206-da48bb5bdbf0",
        "clerk": {
          "publishableKeyDev": "pk_test_Y29tcGxldGUtbWVlcmthdC02NS5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmdvd3BpLm9yZyQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "supportUrl": "",
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "AI Learning Agent",
        "alias": "Q",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/wpi/assets/icons/icon.png",
        "showOriginalQuestion": false,
        "initialMessage": "Hey there! I'm {{alias}}, your {{title}}, and I'm here to help you better prepare for {{context}}. Let's take a closer look at the question you answered on {{topic}}."
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": false,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for WPI"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official WPI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/wpi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "avatarType": "initials",
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": false
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:52.037Z",
            "version": "1.0.19"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": false,
      "allowChangeExam": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Domain mastery",
      "showRedeem": false
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery"
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "title": "Your privacy matters",
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "Here's how we protect and use your data"
        },
        "isMobile": true,
        "ctai18n": {
          "en-US": "Continue"
        },
        "data": [
          {
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "icon": "shield-check-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "icon": "lock-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "titlei18n": {
              "en-US": "You control your data"
            },
            "icon": "account-cog-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam",
        "description": "onboarding.steps.chooseContext.description"
      },
      {
        "step": "examDate",
        "enabled": true,
        "title": "Choose your Exam Date",
        "description": "onboarding.steps.testDate.description"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true
          },
          {
            "title": "Library",
            "name": "(articles)/articles",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "cta": "Study Now",
      "showFlightCalculator": false,
      "maxItems": {
        "flashcards": 100,
        "questions": 50
      },
      "timer": false,
      "showCrossOut": true,
      "selectionStrategy": {
        "default": "random",
        "optimized": true,
        "random": true,
        "shuffled": true
      }
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(145, 144, 154)",
          "primary": "rgb(189, 194, 255)",
          "surface": "rgb(27, 27, 31)",
          "backdrop": "rgba(48, 48, 56, 0.4)",
          "tertiary": "rgb(231, 185, 213)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(35, 35, 42)",
            "level2": "rgb(40, 40, 49)",
            "level3": "rgb(45, 45, 56)",
            "level4": "rgb(46, 47, 58)",
            "level5": "rgb(50, 50, 62)"
          },
          "onPrimary": "rgb(3, 18, 160)",
          "onSurface": "rgb(228, 225, 230)",
          "secondary": "rgb(79, 216, 235)",
          "background": "rgb(27, 27, 31)",
          "onTertiary": "rgb(69, 38, 60)",
          "onSecondary": "rgb(0, 54, 61)",
          "onBackground": "rgb(228, 225, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(67, 79, 205)",
          "inverseSurface": "rgb(228, 225, 230)",
          "outlineVariant": "rgb(70, 70, 79)",
          "surfaceVariant": "rgb(70, 70, 79)",
          "surfaceDisabled": "rgba(228, 225, 230, 0.12)",
          "inverseOnSurface": "rgb(48, 48, 52)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(199, 197, 208)",
          "primaryContainer": "rgb(40, 52, 181)",
          "onSurfaceDisabled": "rgba(228, 225, 230, 0.38)",
          "tertiaryContainer": "rgb(94, 60, 83)",
          "onPrimaryContainer": "rgb(224, 224, 255)",
          "secondaryContainer": "rgb(0, 79, 88)",
          "onTertiaryContainer": "rgb(255, 215, 239)",
          "onSecondaryContainer": "rgb(151, 240, 255)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(119, 118, 128)",
          "primary": "rgb(67, 79, 205)",
          "surface": "rgb(255, 251, 255)",
          "backdrop": "rgba(48, 48, 56, 0.4)",
          "tertiary": "rgb(120, 83, 107)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(246, 242, 253)",
            "level2": "rgb(240, 237, 251)",
            "level3": "rgb(234, 232, 250)",
            "level4": "rgb(232, 230, 249)",
            "level5": "rgb(229, 227, 248)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(27, 27, 31)",
          "secondary": "rgb(0, 104, 116)",
          "background": "rgb(255, 251, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(27, 27, 31)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(189, 194, 255)",
          "inverseSurface": "rgb(48, 48, 52)",
          "outlineVariant": "rgb(199, 197, 208)",
          "surfaceVariant": "rgb(227, 225, 236)",
          "surfaceDisabled": "rgba(27, 27, 31, 0.12)",
          "inverseOnSurface": "rgb(243, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(70, 70, 79)",
          "primaryContainer": "rgb(224, 224, 255)",
          "onSurfaceDisabled": "rgba(27, 27, 31, 0.38)",
          "tertiaryContainer": "rgb(255, 215, 239)",
          "onPrimaryContainer": "rgb(0, 6, 103)",
          "secondaryContainer": "rgb(151, 240, 255)",
          "onTertiaryContainer": "rgb(46, 17, 38)",
          "onSecondaryContainer": "rgb(0, 31, 36)"
        }
      }
    }
  },
  "nascla": {
    "tenant": {
      "id": "6635a8d9-38e4-4051-928c-42df9e591995",
      "name": "NASCLA"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "NASCLA",
    "app": {
      "id": "bcba4050-d047-49c7-a863-ad0d3b7b799c",
      "name": "NASCLA Exam Prep and Directory",
      "scheme": "nascla.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6752681081"
        },
        "android": {
          "versionCode": 19,
          "package": "com.memorang.nascla",
          "googleServicesJson": "48620254-487b-44a1-80e6-6319e8a76cd6",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.nascla",
          "buildNumberState": {
            "currentVersion": "1.0.16",
            "buildNumber": 1
          }
        }
      },
      "version": "1.0.22",
      "maintenance": {
        "enabled": false,
        "title": "We'll be right back",
        "urls": {
          "ios": "",
          "android": ""
        },
        "subtitle": "We're currently making improvements to enhance your experience. We apologize for any inconvenience and appreciate your patience."
      },
      "font": "opensans",
      "trademark": "NASCLA",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "282437d9532186634a11c1766aaa9d79"
        }
      },
      "logo": {
        "icon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/icon.png",
        "adaptiveIcon": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/icon.png",
        "stacked": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_stacked_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_stacked_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_default_light.png"
          },
          "dark": {
            "uri": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/nascla/icons/app_logo_default_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.nascla.psiexams.com",
        "privacy": "https://app.nascla.psiexams.com/legal/privacy",
        "tos": "https://app.nascla.psiexams.com/legal/terms",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
        "companyUrl": "https://www.nascla.org/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_ccxywHbvHLWINlyzqbXuejIwZFj",
          "android": "goog_MwTFBdxrtZcnfnbKAnxdFEfhmAO"
        },
        "oneSignalAppId": "72f30699-4b1c-4ec7-9795-747a60cd5045",
        "clerk": {
          "publishableKeyDev": "pk_test_c3dlZXBpbmctZW11LTY3LmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLm5hc2NsYS5wc2lleGFtcy5jb20k"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "NASCLA Ai Learning Agent",
        "alias": "NAiLA",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/nascla/assets/icons/icon.png",
        "showOriginalQuestion": false,
        "initialMessage": "Hey there! I'm {{alias}}, your {{title}}, and I'm here to help you better prepare for {{context}}. Let's take a closer look at the question you answered on {{topic}}."
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for NASCLA Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official NASCLA team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalized AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showFaqs": false,
        "showPurchasedProducts": false,
        "showCurrentExam": true,
        "faqs": [],
        "showLanguageSettings": false,
        "showAudioTestDialog": false,
        "showPartnersSection": false
      },
      "citations": {
        "visible": true,
        "showTextBasedCitationOnly": false
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:52.024Z",
            "version": "1.0.22"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": true,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Topic Mastery",
      "showRedeem": true
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Directory",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "showFlightCalculator": false,
      "showCrossOut": true
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(163, 201, 255)",
          "surface": "rgb(26, 28, 30)",
          "backdrop": "rgba(45, 49, 55, 0.4)",
          "tertiary": "rgb(217, 189, 227)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(33, 37, 41)",
            "level2": "rgb(37, 42, 48)",
            "level3": "rgb(41, 47, 55)",
            "level4": "rgb(42, 49, 57)",
            "level5": "rgb(45, 52, 62)"
          },
          "onPrimary": "rgb(0, 49, 92)",
          "onSurface": "rgb(227, 226, 230)",
          "secondary": "rgb(255, 182, 136)",
          "background": "rgb(26, 28, 30)",
          "onTertiary": "rgb(60, 41, 71)",
          "onSecondary": "rgb(81, 36, 0)",
          "onBackground": "rgb(227, 226, 230)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(22, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 130)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(84, 63, 94)",
          "onPrimaryContainer": "rgb(211, 227, 255)",
          "secondaryContainer": "rgb(115, 54, 0)",
          "onTertiaryContainer": "rgb(245, 217, 255)",
          "onSecondaryContainer": "rgb(255, 219, 199)"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(115, 119, 127)",
          "primary": "rgb(22, 96, 165)",
          "surface": "rgb(253, 252, 255)",
          "backdrop": "rgba(45, 49, 55, 0.4)",
          "tertiary": "rgb(109, 86, 119)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(241, 244, 251)",
            "level2": "rgb(235, 240, 248)",
            "level3": "rgb(228, 235, 245)",
            "level4": "rgb(225, 233, 244)",
            "level5": "rgb(221, 230, 242)"
          },
          "onPrimary": "rgb(255, 255, 255)",
          "onSurface": "rgb(26, 28, 30)",
          "secondary": "rgb(149, 73, 7)",
          "background": "rgb(253, 252, 255)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "rgb(255, 255, 255)",
          "onBackground": "rgb(26, 28, 30)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(163, 201, 255)",
          "inverseSurface": "rgb(47, 48, 51)",
          "outlineVariant": "rgb(195, 198, 207)",
          "surfaceVariant": "rgb(223, 226, 235)",
          "surfaceDisabled": "rgba(26, 28, 30, 0.12)",
          "inverseOnSurface": "rgb(241, 240, 244)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(67, 71, 78)",
          "primaryContainer": "rgb(211, 227, 255)",
          "onSurfaceDisabled": "rgba(26, 28, 30, 0.38)",
          "tertiaryContainer": "rgb(245, 217, 255)",
          "onPrimaryContainer": "rgb(0, 28, 56)",
          "secondaryContainer": "rgb(255, 219, 199)",
          "onTertiaryContainer": "rgb(38, 20, 48)",
          "onSecondaryContainer": "rgb(49, 19, 0)"
        }
      }
    }
  },
  "psi": {
    "tenant": {
      "id": "dcfc373c-0870-4a88-88c3-4a706de51463",
      "name": "PSI"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "PSI",
    "app": {
      "id": "2c183c41-6dc0-4ef4-837c-0eb0f86a61b1",
      "name": "PSI Test Prep",
      "scheme": "psi.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1565909858"
        },
        "android": {
          "versionCode": 135,
          "package": "com.memorang.psi.insurance.testprep",
          "googleServicesJson": "c4e1d731-8e5a-4d9a-a6c0-694c2117e1a7",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.insurance",
          "buildNumberState": {
            "currentVersion": "2.1.45",
            "buildNumber": 16
          }
        }
      },
      "version": "2.1.48",
      "maintenance": {
        "enabled": false,
        "title": "We'll be right back",
        "urls": {
          "ios": "https://apps.apple.com/us/app/psi-test-prep/id1565909858",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en_IN"
        },
        "subtitle": "We are currently making improvements to enhance your experience. The PSI app is temporarily unavailable due to maintenance. We apologize for any inconvenience and appreciate your patience. Once maintenance is complete, the current version of the app will no longer be supported. 👉 If you are on mobile, please update to the latest version of the app from the App Store or Google Play Store to continue using it."
      },
      "font": "beausite",
      "trademark": "PSI",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "e2354d451161a9deacf641952f49ab00"
        }
      },
      "logo": {
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/icon.png",
        "adaptiveIcon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_light.png?t=2024-09-11T02%3A52%3A07.652Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_dark.png?t=2024-09-11T02%3A52%3A21.053Z"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_light.png?t=2024-09-11T02%3A52%3A32.632Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_dark.png?t=2024-09-11T02%3A52%3A42.516Z"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.psiexams.com",
        "privacy": "https://app.psiexams.com/legal/privacy",
        "tos": "https://app.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/in/app/psi-test-prep/id1565909858",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
        "redeemSupportUrl": "https://app.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_tfbBxQbsoZLVyISjLSZWoccqCzi",
          "android": "goog_xnLVKZpZmlknMbzVJXNOLTdigye"
        },
        "oneSignalAppId": "67d6088f-0bcd-4d04-9984-b5f8efa0dcfc",
        "clerk": {
          "publishableKeyDev": "pk_test_Z2FtZS1saW9uZXNzLTgyLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnBzaWV4YW1zLmNvbSQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "AiLA",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/assistant/assistant_dark.png?t=2024-09-20T04%3A10%3A34.686Z",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PSI Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:52.357Z",
            "version": "2.1.48"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "whiteListedExamIds": [
        "fa"
      ],
      "quizEnabled": true,
      "allowChangeExam": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Topics",
      "showRedeem": false
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "privacy",
        "enabled": true,
        "title": "Your privacy matters",
        "titlei18n": {
          "en-US": "Your privacy matters"
        },
        "descriptioni18n": {
          "en-US": "Here's how we protect and use your data"
        },
        "isMobile": true,
        "ctai18n": {
          "en-US": "Continue"
        },
        "data": [
          {
            "descriptioni18n": {
              "en-US": "We use industry-standard encryption to protect your information."
            },
            "titlei18n": {
              "en-US": "Your data is secure"
            },
            "icon": "shield-check-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Your personal information stays private and is never shared with third parties."
            },
            "titlei18n": {
              "en-US": "We never sell your data"
            },
            "icon": "lock-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Access, download, or delete your data at any time from settings."
            },
            "titlei18n": {
              "en-US": "You control your data"
            },
            "icon": "account-cog-outline"
          },
          {
            "descriptioni18n": {
              "en-US": "Read our full privacy policy to understand exactly how we handle your data."
            },
            "titlei18n": {
              "en-US": "Transparent practices"
            },
            "icon": "file-document-outline"
          }
        ]
      },
      {
        "step": "chooseCategory",
        "enabled": true,
        "title": "Choose Category",
        "titlei18n": {
          "en-US": "What are you studying for?"
        },
        "description": "onboarding.steps.chooseCategory.description",
        "descriptioni18n": {
          "en-US": "Choose the category that applies"
        },
        "ctai18n": {
          "en-US": "Continue with {{category}}"
        }
      },
      {
        "step": "chooseLevel",
        "enabled": true,
        "title": "Choose Level",
        "titlei18n": {
          "en-US": "Which level are you preparing for?"
        },
        "descriptioni18n": {
          "en-US": "Choose one of the options below"
        },
        "ctai18n": {
          "en-US": "Continue"
        }
      },
      {
        "step": "chooseState",
        "enabled": true,
        "title": "Choose State",
        "titlei18n": {
          "en-US": "Select state for the exam"
        },
        "descriptioni18n": {
          "en-US": "Choose the state where you will take the exam"
        },
        "ctai18n": {
          "en-US": "Continue"
        }
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam",
        "titlei18n": {
          "en-US": "Choose your exam"
        },
        "description": "onboarding.steps.chooseContext.description",
        "descriptioni18n": {
          "en-US": "Select your exam to get a personalized study plan"
        },
        "ctai18n": {
          "en-US": "Continue"
        }
      },
      {
        "step": "examDate",
        "enabled": true,
        "title": "Choose your exam date",
        "titlei18n": {
          "en-US": "Choose your exam date"
        },
        "description": "onboarding.steps.testDate.description",
        "descriptioni18n": {
          "en-US": "We’ll tailor your study plan based on this date"
        },
        "ctai18n": {
          "en-US": "Set date"
        }
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": null,
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 120, 124)",
          "primary": "#103D4B",
          "surface": "rgb(251, 252, 254)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(88, 100, 0)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 245, 248)",
            "level2": "rgb(231, 240, 244)",
            "level3": "rgb(223, 236, 240)",
            "level4": "rgb(221, 234, 239)",
            "level5": "rgb(216, 231, 236)"
          },
          "onPrimary": "#F2E9D8",
          "onSurface": "rgb(25, 28, 29)",
          "secondary": "#BC5221",
          "background": "rgb(251, 252, 254)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "#fff",
          "onBackground": "rgb(25, 28, 29)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(93, 212, 252)",
          "inverseSurface": "rgb(46, 49, 50)",
          "outlineVariant": "rgb(191, 200, 204)",
          "surfaceVariant": "rgb(220, 228, 232)",
          "surfaceDisabled": "rgba(25, 28, 29, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 242)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 72, 76)",
          "primaryContainer": "rgb(184, 234, 255)",
          "onSurfaceDisabled": "rgba(25, 28, 29, 0.38)",
          "tertiaryContainer": "rgb(219, 236, 121)",
          "onPrimaryContainer": "rgb(0, 31, 40)",
          "secondaryContainer": "#F2E9D8",
          "onTertiaryContainer": "rgb(25, 30, 0)",
          "onSecondaryContainer": "#1A212B"
        }
      },
      "roundness": 0
    }
  },
  "faa": {
    "tenant": {
      "id": "17b4c5fe-6373-4ae0-989a-8ee2b79c417c",
      "name": "PSI"
    },
    "supportEmail": "support@app.aviation.psiexams.com",
    "companyName": "PSI",
    "app": {
      "id": "16cf7bb8-047a-418d-bfe8-e6b22e46d7b1",
      "name": "PSI Aviation Test Prep",
      "scheme": "aviation.memorang",
      "auth": {
        "provider": "clerk"
      },
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "6745539866"
        },
        "android": {
          "versionCode": 26,
          "package": "com.memorang.psi.aviation",
          "googleServicesJson": "8002a5c0-e8ff-454a-bc1f-7cdde1224ee2",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.aviation",
          "buildNumberState": {
            "currentVersion": "1.0.7",
            "buildNumber": 2
          }
        }
      },
      "version": "1.0.15",
      "font": "beausite",
      "trademark": "PSI",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "fb3c79e43fdfa23b40bc23fc4e365226"
        }
      },
      "logo": {
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/icon.png",
        "adaptiveIcon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/stacked_app_logo_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/stacked_app_logo_dark.png"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/app_logo_light.png"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/app_logo_dark.png"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.aviation.psiexams.com",
        "privacy": "https://app.aviation.psiexams.com/legal/privacy",
        "tos": "https://app.aviation.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/az/app/psi-aviation-test-prep/id6745539866",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.aviation",
        "redeemSupportUrl": "https://app.aviation.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_DiGjBeJxHsEifBsXveNNGQfVkQq",
          "android": "goog_EJYJzpGCMSnBdgwrrNCQcNwDvzv"
        },
        "oneSignalAppId": "26dc479c-21a6-48e4-9c6f-a51bf569d19c",
        "clerk": {
          "publishableKeyDev": "pk_test_bm92ZWwtc3R1ZC05MC5jbGVyay5hY2NvdW50cy5kZXYk",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLmF2aWF0aW9uLnBzaWV4YW1zLmNvbSQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "tagType": {
        "en-US": "Topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Assistant",
        "alias": "AI Wingman",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/aila.png",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**"
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PSI Aviation Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a Sample test"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/faa/landing.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": true,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_4XZL5N1p3A1yL26je1nWC5iuM5NG",
            "deployedAt": "2026-05-07T14:19:52.043Z",
            "version": "1.0.15"
          }
        }
      },
      "leaderboards": {
        "timePeriods": [
          "all_time",
          "month",
          "week"
        ],
        "scopes": [
          "global",
          "friends"
        ],
        "showUsersPodium": true,
        "numUsersToDisplay": 10
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "diagnosticLabel": {
        "en-US": "free sample test"
      },
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Sample tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format."
          },
          "practiceTest": {
            "severity": "info",
            "icon": "clipboard-text-outline",
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "quizAndPracticeTest": {
            "severity": "info",
            "icon": "format-list-checks",
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish."
          },
          "topicMastery": {
            "severity": "info",
            "icon": "chart-line",
            "title": "Mastery Breakdown",
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing."
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": false
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Subject mastery",
      "showRedeem": true
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study-Pack",
            "name": "study-pack",
            "icon": {
              "default": "study-pack-outline",
              "selected": "study-pack"
            },
            "enabled": false,
            "custom": true
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": {
      "disclaimer": "The FAA testing system includes supplemental publications containing graphics, legends, and maps essential for accurately answering specific exam questions. These resources can be accessed here: [https://www.faa.gov/training_testing/testing/supplements/media/sport_rec_private_akts.pdf](https://www.faa.gov/training_testing/testing/supplements/media/sport_rec_private_akts.pdf).\n\\\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam.",
      "welcomeDialog": {
        "diagnostic": {
          "title": "Welcome to your {{examName}}.",
          "body": "The sample test questions are not intended to be used as a study guide; they are a representation of the material that will be found on your actual knowledge test. When you take the real test, you’ll see a tutorial walking you through its navigation and functionality. Although you can access and review the questions as much as you desire, it is recommended you allow enough time to complete the sample test in one sitting and free from distractions.\n\\\nThe total time allotted to complete the exam is **{{hr}} hours or {{min}} minutes**, which is an average of **{{sec}} seconds** per question.\n\\\nFeel free to navigate between questions as you work through them. Once you have finished the test, you will receive a score report with an analysis of your results. Be sure to click on “Review Answers” where you can go question-by-question with additional explanations and help. Good luck!\n\\\n**Disclaimer:**\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam."
        },
        "disclaimer": "**Disclaimer:**\nThis prep material is independently developed and does not contain actual test questions from the Unmanned Aircraft General (UAG) exam. No secure or official exam content was used or referenced in its creation. All content is original and designed to support users by aligning with the Airman Certification Standards (ACS) codes, which outline the knowledge areas covered on the exam."
      },
      "showFlightCalculator": true,
      "showCrossOut": true
    },
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 120, 124)",
          "primary": "#103D4B",
          "surface": "rgb(251, 252, 254)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(88, 100, 0)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 245, 248)",
            "level2": "rgb(231, 240, 244)",
            "level3": "rgb(223, 236, 240)",
            "level4": "rgb(221, 234, 239)",
            "level5": "rgb(216, 231, 236)"
          },
          "onPrimary": "#F2E9D8",
          "onSurface": "rgb(25, 28, 29)",
          "secondary": "#BC5221",
          "background": "rgb(251, 252, 254)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "#fff",
          "onBackground": "rgb(25, 28, 29)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(93, 212, 252)",
          "inverseSurface": "rgb(46, 49, 50)",
          "outlineVariant": "rgb(191, 200, 204)",
          "surfaceVariant": "rgb(220, 228, 232)",
          "surfaceDisabled": "rgba(25, 28, 29, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 242)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 72, 76)",
          "primaryContainer": "rgb(184, 234, 255)",
          "onSurfaceDisabled": "rgba(25, 28, 29, 0.38)",
          "tertiaryContainer": "rgb(219, 236, 121)",
          "onPrimaryContainer": "rgb(0, 31, 40)",
          "secondaryContainer": "#F2E9D8",
          "onTertiaryContainer": "rgb(25, 30, 0)",
          "onSecondaryContainer": "#1A212B"
        }
      },
      "roundness": 0
    }
  }
} as unknown as ConfigMap;